module.exports = __webpack_public_path__ + "static/media/PSG-BNB.698f5bba.svg";